"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoAndLinksContainer = exports.LinkedSite = exports.RegionalContainer = exports.Break = exports.Image = exports.LogoContainer = exports.MyHaldexIcon = exports.MyHaldexContainer = exports.SearchIcon = exports.OtherContainer = exports.Link = exports.HeaderItemsTitle = exports.HeaderLinks = exports.HeaderItems = exports.ItemsContainer = exports.Header = exports.HeaderItem = exports.Background = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("../../UI/Typography"));
const Container_1 = __importDefault(require("../../../Components/UI/Container"));
const svg_components_1 = require("../../../assets/svg-components");
exports.Background = styled_components_1.default.div `
  display: ${props => (props.isOpen ? 'block' : 'none')};
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  animation: ${props => props.theme.animations.easeInOut}
    ${props => (props.isOpen ? props.theme.themeKeyframes.fadeIn : props.theme.themeKeyframes.fadeOut)} forwards;
  z-index: ${props => props.theme.attributes.zIndex.headerBackground};
  height: 100vh;
  width: 100%;
`;
exports.HeaderItem = styled_components_1.default.div `
  cursor: pointer;
  :not(:first-child) {
    padding: 0 ${props => props.theme.spacing.s3}px;
    @media (max-width: ${props => props.theme.breakpoints.xxxl}px) {
      padding: 0 ${props => props.theme.spacing.s7}px;
    }
  }

  :first-child {
    padding-right: ${props => props.theme.spacing.s3}px;
    @media (max-width: ${props => props.theme.breakpoints.xxxl}px) {
      padding-right: ${props => props.theme.spacing.s7}px;
    }
  }

  &::after {
    content: '';
    display: block;
    width: ${props => (props.isActive ? '100%' : '0%')};
    animation: ${props => !props.isActive
    ? props.theme.themeKeyframes.widthResize(100, 0)
    : props.theme.themeKeyframes.widthResize(0, 100)}
      0.3s forwards;
    height: ${props => props.theme.constants.headerItem.borderHeight}px;
    background-color: ${props => props.theme.palette.ORANGE_100};
  }
`;
exports.Header = styled_components_1.default.nav `
  position: ${props => (props.isFixed ? 'fixed' : 'sticky')};
  top: ${props => !props.isFixed && 0};
  width: 100%;
  z-index: ${props => props.theme.attributes.zIndex.header};
  animation: ${props => (props.$isTransparent ? props.theme.animations.easeMedium : props.theme.animations.easeShort)}
    ${props => props.$isTransparent
    ? props.theme.themeKeyframes.fadeToTransparent(props.theme.palette.BW_100)
    : props.theme.themeKeyframes.fadeToColor(props.theme.palette.BW_100)}
    forwards;
  box-shadow: ${props => (props.$isScrolled ? props.theme.attributes.boxShadow.regular : 'none')};
  pointer-events: none;

  @media print {
    display: none;
  }
`;
exports.ItemsContainer = (0, styled_components_1.default)(Container_1.default) `
  pointer-events: auto;
`;
exports.HeaderItems = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  padding: ${props => props.theme.spacing.m1}px 0;
  justify-content: space-between;
`;
exports.HeaderLinks = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  ${props => props.corporate && `margin-left: ${props.theme.spacing.m4}px;`}
`;
exports.HeaderItemsTitle = (0, styled_components_1.default)(Typography_1.default) `
  cursor: pointer;
`;
exports.Link = styled_components_1.default.a `
  transition: ${props => props.theme.attributes.transition.fast};
  color: ${props => (props.$isTransparent ? props.theme.palette.BW_100 : 'inherit')};
  text-decoration: none;
`;
exports.OtherContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  align-items: center;
`;
exports.SearchIcon = (0, styled_components_1.default)(svg_components_1.SearchIcon) `
  cursor: pointer;
  margin-left: ${props => props.theme.spacing.m1}px;
  ${props => props.$lowerMargin && `margin-left: ${props.theme.spacing.s2}px;`}

  > path {
    transition: ${props => props.theme.attributes.transition.fast};
    stroke: ${props => (props.$isTransparent ? props.theme.palette.BW_100 : props.theme.palette.LIGHT_BLACK)};
  }
`;
exports.MyHaldexContainer = styled_components_1.default.button `
  border: 0;
  background-color: transparent;
  position: relative;
`;
exports.MyHaldexIcon = (0, styled_components_1.default)(svg_components_1.UserIcon) `
  margin-left: ${props => props.theme.spacing.m1}px;
  cursor: pointer;

  > path {
    transition: ${props => props.theme.attributes.transition.fast};
    stroke: ${props => (props.$isTransparent ? props.theme.palette.BW_100 : props.theme.palette.LIGHT_BLACK)};
  }
`;
exports.LogoContainer = styled_components_1.default.div `
  height: ${props => props.theme.constants.headerItem.logoHeight}px;
  margin: 0 ${props => props.theme.spacing.s5}px 0 0;
  ${props => props.$lowerMargin && `margin: 0 ${props.theme.spacing.s3}px 0 0;`}
`;
exports.Image = styled_components_1.default.img `
  height: 100%;
  cursor: pointer;
`;
exports.Break = styled_components_1.default.div `
  flex-basis: 100%;
  height: 0;
`;
exports.RegionalContainer = styled_components_1.default.div `
  margin-top: ${props => props.theme.spacing.s5}px;
`;
exports.LinkedSite = styled_components_1.default.a `
  margin-right: ${props => ((props === null || props === void 0 ? void 0 : props.isRegional) ? `${props.theme.spacing.m6}` : `${props.theme.spacing.m1}`)}px;
  padding-top: ${props => props.theme.spacing.s7}px;
`;
exports.LogoAndLinksContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
`;
exports.default = {
    HeaderItem: exports.HeaderItem,
    Header: exports.Header,
    ItemsContainer: exports.ItemsContainer,
    HeaderItems: exports.HeaderItems,
    HeaderItemsTitle: exports.HeaderItemsTitle,
    Link: exports.Link,
    OtherContainer: exports.OtherContainer,
    SearchIcon: exports.SearchIcon,
    LogoContainer: exports.LogoContainer,
    Image: exports.Image,
    LinkedSite: exports.LinkedSite,
    LogoAndLinksContainer: exports.LogoAndLinksContainer
};
